import { useState } from 'react';
import { LockFill, ExclamationCircle, Globe } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';

import { Button, List, Space, Typography } from 'antd';
import TextArea from 'antd/es/input/TextArea';

import CommentItem from '@/components/shared/CommentItem';
import { useAppSelector } from '@/hooks/redux';
import { enCommentStatus, IComment } from '@/interfaces/comments';
import { commentsApi, useSaveReplyMutation } from '@/services/comments';
import { useGetLessonsQuery } from '@/services/lesson';
import styled, { StyledProp } from '@/styled';

import Delete from './Delete';

const Actions = (props: IComment & StyledProp & { isReply: boolean }) => {
  const { id } = useParams();
  const [text, setText] = useState('');
  const [answer, setAnswer] = useState(false);
  const [showReplies, setShowReplies] = useState(false);
  const [saveReply] = useSaveReplyMutation();
  const user = useAppSelector(({ auth }) => auth.user);
  const [getReplies, replies] = commentsApi.endpoints.getReplies.useLazyQuery();

  const fetchNewPage = () => {
    getReplies({
      lessonId: id,
      parentId: props.id,
      params: { ...replies.data?.page, page: replies.data?.page.page + 1 }
    });
  };

  const lesson = useGetLessonsQuery(id);

  const toggleReplies = () => {
    setShowReplies(isShowing => !isShowing);
    getReplies({ lessonId: id, parentId: props.id, params: { page: 1 } });
  };

  const toggleAnswer = () => {
    setAnswer(isActive => !isActive);
  };
  const handleSaveReply = () => {
    saveReply({ lessonId: id, parentId: props.id, comment: text });
  };

  return (
    <div className={props.className}>
      <Space size={16} className='buttons'>
        {props?.totalReplies > 0 && (
          <Typography.Text underline onClick={toggleReplies}>
            {!showReplies && 'Ver comentários'}
            {showReplies && 'Ocultar comentários'}
          </Typography.Text>
        )}
        {props?.user?.id !== user?.id && !props.isReply && lesson.data?.can_reply && (
          <Typography.Text underline onClick={toggleAnswer}>
            Responder
          </Typography.Text>
        )}

        <Delete {...props} />

        {props?.status !== enCommentStatus['waiting-aproval'] && (
          <Typography.Text>
            {props?.status === enCommentStatus.public && (
              <div className='comment-status-icons'>
                <Globe /> Comentário público
              </div>
            )}
            {props?.status === enCommentStatus.private && (
              <div className='comment-status-icons'>
                <LockFill />
                Comentário privado
              </div>
            )}
          </Typography.Text>
        )}

        {props?.status === enCommentStatus['waiting-aproval'] && (
          <div className='comment-status-icons'>
            <ExclamationCircle /> Aguardando moderação
          </div>
        )}
      </Space>

      {showReplies && (
        <List
          loadMore={
            replies.data?.total_pages > 1 && (
              <Button
                disabled={replies.isFetching || replies.data?.page?.page >= replies.data?.total_pages}
                onClick={fetchNewPage}
              >
                Carregar mais comentários
              </Button>
            )
          }
          locale={{ emptyText: 'Nenhum comentário encontrado' }}
          dataSource={replies.data?.data}
          renderItem={comment => (
            <CommentItem key={props.id} comment={comment} isTextSanitized={user.id !== comment.user.id}>
              <Actions {...comment} isReply={true} />
            </CommentItem>
          )}
        />
      )}

      {answer && (
        <div className='action'>
          <TextArea
            size='large'
            rows={1}
            placeholder='Insira seu comentário aqui'
            value={text}
            onChange={e => setText(e.target.value)}
          />
          <Button disabled={!text} type='primary' size='large' onClick={handleSaveReply}>
            Comentar
          </Button>
        </div>
      )}
    </div>
  );
};

export default styled(Actions)`
  .buttons {
    flex-wrap: wrap;
  }

  .ant-typography {
    cursor: pointer;
  }

  button {
    width: fit-content;
  }

  .comment-status-icons {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: auto;
  }
`;
